import { InquiryCustomFieldModel } from './InquiryCustomFieldModel';
export class InquiryCustomAnswerModel {
    constructor(payload) {
        const { content, inquiryCustomField } = payload;
        this.content = content;
        this.customField = new InquiryCustomFieldModel(inquiryCustomField);
    }
}
